import { initDataLayer, isBrowser, persistTrackingData } from '../util';
import { pushFilterNoResults } from '../filters/pushFilterNoResults';
import { mapFlight } from '../util/mapFlight';
export function pushFlightSearchResults(data) {
    var _a, _b, _c;
    if (!isBrowser())
        return;
    initDataLayer();
    const flightSearchResults = (_b = (_a = data.flightSearchResults) === null || _a === void 0 ? void 0 : _a.flights) === null || _b === void 0 ? void 0 : _b.map((flightSearchResult, index) => {
        return mapFlight(flightSearchResult, index);
    });
    window.dataLayer.push({
        event: 'flightSearchResultsLoaded',
        flightSearchResults,
    });
    if (((_c = data.flightSearchResults) === null || _c === void 0 ? void 0 : _c.filteredFlights) === 0) {
        pushFilterNoResults();
    }
    persistTrackingData({ flightSearchResults });
}
